const createRestrictToDroppableRegion = maxHeight => ({
  transform,
  draggingNodeRect,
  over,
  windowRect
}) => {
  if (!draggingNodeRect || !over || !windowRect) {
    return transform;
  }
  return restrictToDroppableRect(transform, draggingNodeRect, {
    ...windowRect,
    top: (1 - maxHeight) * windowRect.height,
    height: maxHeight * windowRect.height
  });
};
function restrictToDroppableRect(transform, rect, boundingRect) {
  const value = {
    ...transform
  };
  if (rect.top + transform.y <= boundingRect.top) {
    value.y = boundingRect.top - rect.top;
  } else if (rect.bottom + transform.y >= boundingRect.top + boundingRect.height) {
    value.y = boundingRect.top + boundingRect.height - rect.bottom;
  }
  if (rect.left + transform.x <= boundingRect.left) {
    value.x = boundingRect.left - rect.left;
  } else if (rect.right + transform.x >= boundingRect.left + boundingRect.width) {
    value.x = boundingRect.left + boundingRect.width - rect.right;
  }
  return value;
}
function isSheetExpanded(expansion) {
  return expansion === 'full' || expansion === 'mid';
}

export { createRestrictToDroppableRegion, isSheetExpanded, restrictToDroppableRect };
